// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/GTEestiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/AvenirBook.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/AvenirBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/AvenirOblique.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2014-2024                        *
 *                                                     *
 *******************************************************/
/* width */
/* fonts */
@font-face {
  font-family: GTEestiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: AvenirBook;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: AvenirBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: AvenirOblique;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
/* debug */
.debug-Rp1vk {
  background-color: #ff7f50;
}
.debug2-LsJ_H {
  background-color: #6495ed;
}
.vtform-XesJu {
  box-sizing: border-box;
  width: 100%;
}
.vtform-XesJu .loadingicon-czlW7 {
  margin-left: 10px;
  height: 18px;
}
.vtform-XesJu .form-YHLfm {
  padding: 20px;
  background-color: #333333;
  border-radius: 20px;
}
.vtform-XesJu .form-YHLfm .title-LaBSl {
  margin-bottom: 20px;
  font-size: 1.25em;
  font-family: "GTEestiBold";
  color: #FFFFFF;
}
.vtform-XesJu .form-YHLfm .formelements-OeHyZ {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
.vtform-XesJu .form-YHLfm .formelements-OeHyZ .formelement-H_45R {
  flex: 1;
  min-width: 220px;
}
.vtform-XesJu .form-YHLfm .formelements-OeHyZ .formelement-H_45R .button-XsrLb {
  width: 100%;
}
.vtform-XesJu .debug-Rp1vk {
  width: 90%;
  margin: 20px auto;
  border: 1px solid #DDDDDD;
  text-align: left;
  font-family: "Courier New";
  font-size: 12px;
}
.vtform-XesJu .debug-Rp1vk h2 {
  text-align: center;
}
.vtform-XesJu .errors-_oOrm {
  width: 90%;
  margin: 20px auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/VTForm/VTForm.module.less","webpack://./src/assets/css/theme.less"],"names":[],"mappings":"AAAA;;;;;;;;wDAQwD;AACxD,UAAU;AACV,UAAU;ACwBV;EAAY,wBAAA;EAA0B,4CAAA;ADpBtC;ACqBA;EAAY,uBAAA;EAAyB,4CAAA;ADjBrC;ACkBA;EAAY,wBAAA;EAA0B,4CAAA;ADdtC;ACeA;EAAY,0BAAA;EAA4B,4CAAA;ADXxC;AACA,UAAU;ACiBV;EAAQ,yBAAA;ADdR;ACeA;EAAS,yBAAA;ADZT;AAhCA;EAAQ,sBAAA;EAAwB,WAAA;AAoChC;AApCA;EACe,iBAAA;EAAmB,YAAA;AAuClC;AAxCA;EAEQ,aAAA;EAAc,yBAAA;EAA8B,mBAAA;AA2CpD;AA7CA;EAGW,mBAAA;ECoCT,iBAAA;EDpC4C,0BAAA;EAA2B,cAAA;AAgDzE;AAnDA;EAIkB,aAAA;EAAc,SAAA;EAAU,eAAA;AAoD1C;AAxDA;EAKmB,OAAA;EAAQ,gBAAA;AAuD3B;AA5DA;EAMgB,WAAA;AAyDhB;AA/DA;EAUS,UAAA;EAAY,iBAAA;EAAmB,yBAAA;EAA2B,gBAAA;EAAkB,0BAAA;EAA4B,eAAA;AA6DjH;AAvEA;EAWO,kBAAA;AA+DP;AA1EA;EAaU,UAAA;EAAY,iBAAA;AAiEtB","sourcesContent":["@import \"../../assets/css/theme\";\n.vtform{box-sizing: border-box; width: 100%;\n  .loadingicon{margin-left: 10px; height: 18px;}\n  .form{padding:20px; background-color:@colorgris4; border-radius: 20px;\n    .title{margin-bottom: 20px;.font-base(20);font-family:\"GTEestiBold\"; color:#FFFFFF;}\n    .formelements{display:flex; gap:20px; flex-wrap: wrap;\n      .formelement{flex:1; min-width: 220px;\n        .button{width:100%;}\n      }\n    }\n  }\n  .debug{width: 90%; margin: 20px auto; border: 1px solid #DDDDDD; text-align: left; font-family: \"Courier New\"; font-size: 12px;\n    h2{text-align: center;}\n  }\n  .errors{width: 90%; margin: 20px auto;}\n}\n\n\n","/*******************************************************\n *                                                     *\n *                VIAJES TEIDE                         *\n *                                                     *\n *        developed: Javier Vega Martinez              *\n *        contact: info@emdbwebprojects.com            *\n *        copyright - 2014-2024                        *\n *                                                     *\n *******************************************************/\n\n//VARS\n\n@colorverde1: #99CC33;  //verde 1\n@colorverde2: #009933;  //verde 2\n@colorverde3: #BEE266;  //verde 3\n@colorazul1: #33CCFF;   //azul 1\n@colorrosa1: #FF6698;   //rosa 1\n\n@colorgris1: #E1E1E1;   //Gris background footer\n@colorgris2: #999999;   //Gris text\n@colorgris3: #666666;   //Gris text\n@colorgris4: #333333;   //Gris text\n@colorgris5: #5D5D5D;\n\n/* width */\n@width-space:20px;\n@width-column:40px;\n@width-content: 1100px;\n@width-total: @width-content + 20px;\n@width-min:400px;\n\n/* fonts */\n@em:16px;\n\n@font-face {font-family: GTEestiBold; src: url('../fonts/GTEestiBold.otf'); }\n@font-face {font-family: AvenirBook; src: url('../fonts/AvenirBook.otf'); }\n@font-face {font-family: AvenirBlack; src: url('../fonts/AvenirBlack.ttf'); }\n@font-face {font-family: AvenirOblique; src: url('../fonts/AvenirOblique.otf'); }\n\n.font-base(@sizeValue) {\n  font-size: unit(( @sizeValue / @em ), em);\n}\n\n/* debug */\n.debug {background-color:#ff7f50;}\n.debug2 {background-color:#6495ed ;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debug": `debug-Rp1vk`,
	"debug2": `debug2-LsJ_H`,
	"vtform": `vtform-XesJu`,
	"loadingicon": `loadingicon-czlW7`,
	"form": `form-YHLfm`,
	"title": `title-LaBSl`,
	"formelements": `formelements-OeHyZ`,
	"formelement": `formelement-H_45R`,
	"button": `button-XsrLb`,
	"errors": `errors-_oOrm`
};
export default ___CSS_LOADER_EXPORT___;
